import React, { Component } from 'react';
import "./styles.css"
import { configuration } from './../../configuration'

class GraciasConCita extends Component {

  render() {
    const clientImage = configuration().clientLogo
    // Required: Used in template string into configuration
    const year = new Date().getFullYear()
    const gratitudeFooterText = eval('`'+configuration().gratitudeFooterText+'`')
    return (
        <div>
            <main role="main" className="container">
                <div className="gratitude-center-content">
                    <img src={clientImage} className="img-fluid" alt="logo Syrsa"></img>
                    <br/><br/>
                    <h1>{configuration().GraciasConCitaParagraph1 ? configuration().GraciasConCitaParagraph1 : '¡Lo tenemos!'}</h1>
                    <p className="lead">{configuration().GraciasConCitaParagraph2 ? configuration().GraciasConCitaParagraph2 : 'Muchas gracias por confiar en nosotros,'}<br/>{configuration().GraciasConCitaParagraph3 ? configuration().GraciasConCitaParagraph3 : 'ya tenemos todos los datos de tu cita. ¡Te esperamos!'}</p>
                </div>
            </main>
            <div className="minifooter">
                <p>
                {gratitudeFooterText}
                </p>
            </div>
        </div>
    )
  }
}

export default GraciasConCita;


// WEBPACK FOOTER //
// ./src/workflow/gratitude/gracias-con-cita.js